import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {triggerSponsorshipAnalyticsEvent} from '../../utils/analytics-helpers';
import { isInteractiveKeyCode, noFuncProps } from "../../utils/helpers";
import { gtmTrackEventData } from "../../utils/gtm-event-triggers";
import { getSponsorshipMonthlyRate } from "../../config/rates";

class SponsorCta extends Component {
  constructor(props) {
    super(props);
  }

  handleKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      (this.props.changeView) ?
      this.props.changeView(e, this.props.identifier, this.props.descriptorIndex) :
      undefined;

      if (this.props.fireAddToCart) {
        const rate = getSponsorshipMonthlyRate();

        // TODO: Remove Legacy Analytics
        triggerSponsorshipAnalyticsEvent("addToCart.sponsorship",{
          productName: "Child Sponsorship",
          productId: this.props.identifier,
          price: rate,
          category: "Sponsorship",
          quantity: 1,
          metric1: rate*1
        });

        // This Analytics Stays
        gtmTrackEventData("spon_app_add_to_cart", {
          "search_props": noFuncProps(this.props.childInfoProps),
          "sponsorship_monthly_rate": rate
        });
      }
    }
  }

  getLink() {
    if (this.props.getCtaLink) {
      return this.props.getCtaLink();
    }

    return this.props.urlLink;
  }

  render() {
    const classList = this.props.classList.join(' ');
    const urlLink = this.getLink();

    return (
      <a 
        className={`child-tile-cta ${classList}`} 
        href={urlLink} 
        onClick={
          (e) => {
            (this.props.changeView)? this.props.changeView(e, this.props.identifier, this.props.descriptorIndex): undefined;
            if (this.props.fireAddToCart) {
              const rate = getSponsorshipMonthlyRate();

              // TODO: Remove Legacy Analytics
              triggerSponsorshipAnalyticsEvent("addToCart.sponsorship", {
                productName: "Child Sponsorship",
                productId: this.props.identifier,
                price: rate,
                category: "Sponsorship",
                quantity: 1,
                metric1: rate*1
              });

              // This Analytics Stays
              gtmTrackEventData("spon_app_add_to_cart", {
                "search_props": noFuncProps(this.props.childInfoProps),
                "sponsorship_monthly_rate": rate
              });
            }
          }
        }
        onKeyUp={(e) => this.handleKeyUp(e)}
        tabIndex="0"
        >
        {this.props.sponsorshipTileCtaText}
        { (this.props.angleRight)? (
          <span className="angle-right">
            <FontAwesomeIcon icon={faAngleRight} />
          </span>
        )  : (
            <></>
        ) }

      </a>
    );
  }
}

export default SponsorCta;
